import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var familyMemberRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
    {
        userRole: UserRole.CompleteUser,
        page: AppRoutes.Plan,
    },
];
var NamePage = React.lazy(function () { return import('../pages/onboarding/name.page'); });
var BirthdayPage = React.lazy(function () { return import('../pages/onboarding/birthday.page'); });
var GenderPage = React.lazy(function () { return import('../pages/onboarding/gender.page'); });
var HeightPage = React.lazy(function () { return import('../pages/onboarding/height.page'); });
var WorkoutPage = React.lazy(function () { return import('../pages/onboarding/workout.page'); });
var AllergiesPage = React.lazy(function () { return import('../pages/onboarding/allergies.page'); });
var DietTypePage = React.lazy(function () { return import('../pages/onboarding/dietType.page'); });
var GrowthSpeedPage = React.lazy(function () { return import('../pages/onboarding/growthSpeed.page'); });
var DislikedIngredientsPage = React.lazy(function () { return import('../pages/onboarding/dislikedIngredients.page'); });
var PlanPreferencesPage = React.lazy(function () { return import('../pages/onboarding/planPreferences.page'); });
var familyMemberRoutes = [
    {
        path: AppRoutes.Base,
        element: _jsx(Navigate, { to: AppRoutes.Intro, replace: true }),
    },
    {
        path: AppRoutes.FamilyMemberName,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(NamePage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberBirthday,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(BirthdayPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberGender,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(GenderPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberHeight,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(HeightPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberWorkout,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(WorkoutPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberDietType,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(DietTypePage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberAllergies,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(AllergiesPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberDislikedIngredientsPage,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(DislikedIngredientsPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberPlanPreferences,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(PlanPreferencesPage, {}) })),
    },
    {
        path: AppRoutes.FamilyMemberGrowthSpeed,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: familyMemberRedirectPages, children: _jsx(GrowthSpeedPage, {}) })),
    },
];
export default familyMemberRoutes;
